import dayjs from 'dayjs'

const DAILY_HOUR = 9
const MONDAY = 1
const DEFAULT_SECOND = 10
const DEFAULT_MINUTE_STEP = 5

const at = (d, { hour, minute, second }) =>
  d.hour(hour).minute(minute).second(second).millisecond(0)

const nextAligned = (now, align, step, unit) => {
  const candidate = align(now)

  return candidate.isAfter(now) ? candidate : align(now.add(step, unit))
}

const nextMonday = (now, time) => {
  let candidate = at(now, time)

  for (let i = 0; i <= 7; i++) {
    if (candidate.isAfter(now) && candidate.day() === MONDAY) return candidate
    candidate = candidate.add(1, 'day')
  }

  return candidate
}

const nextFirstDayOfMonth = (now, time) => {
  const candidate = at(now.date(1), time)

  return candidate.isAfter(now) ? candidate : at(now.add(1, 'month').date(1), time)
}

export const getNextPollingTime = (now, period) => {
  const base = dayjs(now)
  const [unitPart, offsetPart] = String(period).split('-')

  if (offsetPart?.endsWith('s')) {
    const second = Number(offsetPart.replace('s', ''))

    if (unitPart.endsWith('m')) {
      const step = Number(unitPart.replace('m', ''))
      const align = (d) =>
        at(d, { hour: d.hour(), minute: Math.floor(d.minute() / step) * step, second })

      return nextAligned(base, align, step, 'minute').toDate()
    }

    if (unitPart.endsWith('h')) {
      const step = Number(unitPart.replace('h', ''))
      const align = (d) => at(d, { hour: Math.floor(d.hour() / step) * step, minute: 0, second })

      return nextAligned(base, align, step, 'hour').toDate()
    }

    if (unitPart === '1d') {
      const align = (d) => at(d, { hour: DAILY_HOUR, minute: 0, second })

      return nextAligned(base, align, 1, 'day').toDate()
    }

    if (unitPart === '1w') {
      return nextMonday(base, { hour: DAILY_HOUR, minute: 0, second }).toDate()
    }
  }

  const minute = Number(offsetPart || '1')
  const dailyTime = { hour: DAILY_HOUR, minute, second: DEFAULT_SECOND }

  switch (unitPart) {
    case '1s': {
      const align = (d) => d.millisecond(0)

      return nextAligned(base, align, 1, 'second').toDate()
    }

    case '5s': {
      const align = (d) => d.second(Math.floor(d.second() / 5) * 5).millisecond(0)

      return nextAligned(base, align, 5, 'second').toDate()
    }

    case '1m': {
      const align = (d) => at(d, { hour: d.hour(), minute: d.minute(), second: DEFAULT_SECOND })

      return nextAligned(base, align, 1, 'minute').toDate()
    }

    case '1h': {
      const align = (d) => at(d, { hour: d.hour(), minute: 0, second: DEFAULT_SECOND })

      return nextAligned(base, align, 1, 'hour').toDate()
    }

    case '1d': {
      const align = (d) => at(d, dailyTime)

      return nextAligned(base, align, 1, 'day').toDate()
    }

    case '1w':
      return nextMonday(base, dailyTime).toDate()

    case '1mo':
      return nextFirstDayOfMonth(base, dailyTime).toDate()

    default: {
      const align = (d) =>
        at(d, {
          hour: d.hour(),
          minute: Math.floor(d.minute() / DEFAULT_MINUTE_STEP) * DEFAULT_MINUTE_STEP,
          second: DEFAULT_SECOND
        })

      return nextAligned(base, align, DEFAULT_MINUTE_STEP, 'minute').toDate()
    }
  }
}
